import React from "react";
import { Panel, PlainButton, Grid, classnames } from "@culturehq/components";
import * as CHQ from "chq";

import { Trans } from "app/utils";
import eventTypes from "constants/eventTypes";

import styles from "./eventForms/EventForm.module.scss";

type EventType = {
  value: string;
  label: string;
  description: string;
  image: string;
  defaults: () => Omit<Partial<CHQ.Event>, "image"> & {
    image: {
      originalUrl: string;
    };
  };
};

type EventSelectProps = {
  onSetEventType: (_eventType: EventType) => void;
};

type EventTypeCardProps = EventSelectProps & {
  eventType: EventType;
};

const EventTypeCard: React.FC<EventTypeCardProps> = ({ eventType, onSetEventType }) => (
  <Grid.Item sm={4} md={3} className="chq-event-type-card card-space">
    <div className="chq-event-type-card--title">
      <p>{eventType.label}</p>
    </div>
    <PlainButton
      style={{ backgroundImage: `url(${eventType.image})` }}
      onClick={() => onSetEventType(eventType)}
    >
      <div className="cover">
        <p className="description">{eventType.description}</p>
      </div>
    </PlainButton>
  </Grid.Item>
);

const EventSelect: React.FC<EventSelectProps> = ({ onSetEventType }) => (
  <Panel className="EventEdit" limitWidth>
    <Panel.Heading primary>
      <Trans>Choose your Event Category</Trans>
    </Panel.Heading>
    <Panel.Body className="chq-event-edit--edit-type">
      <h2 className={classnames(styles["m-0"])}>
        <Trans>Which type of event would you like to create?</Trans>
      </h2>
      <Grid className={styles["p-10"]}>
        {eventTypes.map(eventType => (
          <EventTypeCard
            key={eventType.value}
            eventType={eventType}
            onSetEventType={onSetEventType}
          />
        ))}
      </Grid>
    </Panel.Body>
  </Panel>
);

export default EventSelect;
